import script from "./Unauthorized.vue?vue&type=script&setup=true&lang=js"
export * from "./Unauthorized.vue?vue&type=script&setup=true&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=dc817c34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc817c34"]])

export default __exports__